// components/CustomTabs.tsx
import React from 'react'
import styles from './style.module.scss'
import ClassName from 'clsx'

interface TabItem {
  key: string
  label: string
}

interface CustomTabsProps {
  value: string
  onChange: (key: string) => void
  items: TabItem[]
}

const CustomTabs: React.FC<CustomTabsProps> = ({ value, onChange, items }) => {
  return (
    <div className={styles.tabContainer}>
      {items.map((item, index) => (
        <React.Fragment key={item.key}>
          <div
            className={ClassName(styles.tabItem, {
              [styles.active]: value === item.key,
            })}
            onClick={() => onChange(item.key)}
          >
            {item.label}
          </div>
          {index < items.length - 1 && <div className={styles.divider} />}
        </React.Fragment>
      ))}
    </div>
  )
}

export default CustomTabs
